// 新公告（首页相关）：
const Announcement = {
  // Announcement_Management: {
  //   code: 270,
  //   name: "新公告模块"
  // },
  Announcement_Management_Add_Or_Update: {
    code: 271,
    name: '新增和修改'
  },
  Announcement_Management_Deltet: {
    code: 272,
    name: '删除'
  },
  Announcement_Management_Query: {
    code: 273,
    name: '管理员分页查询'
  },
  Announcement_Management_Query_For_Read: {
    code: 274,
    name: '查询已经看过公告的用户'
  }
}
// 组织架构：
const Organization = {
  // Organization_Management: {
  //   code: 3,
  //   name: "组织架构"
  // },
  Organization_Management_Upadte_To_Cache: {
    code: 22,
    name: '更新组织架构到缓存'
  },
  Organization_Management_Add_Or_Upadte_Node: {
    code: 23,
    name: '创建或修改组织架构节点'
  },
  Organization_Management_Delete_Node: {
    code: 24,
    name: '删除组织架构节点'
  }
}
// 角色管理：
const RoleAuthority = {
  // RoleAuthority_Management: {
  //   code: 2,
  //   name: "角色和权限"
  // },
  RoleAuthority_Management_Set_For_One: {
    code: 15,
    name: '单独绑定账号可以访问的组织架构节点'
  },
  RoleAuthority_Management_Look_Or_Add: {
    code: 16,
    name: '查看用户角色和添加角色'
  },
  RoleAuthority_Management_Add_Or_Update_Role: {
    code: 17,
    name: '创建,修改,查询角色'
  },
  RoleAuthority_Management_Forbid_Or_Delete: {
    code: 18,
    name: '禁用账号和删除账号'
  },
  RoleAuthority_Management_Look_All_Authority_List: {
    code: 19,
    name: '查看所有的权限列表'
  },
  RoleAuthority_Management_Look_Or_Upadte_Authority_List: {
    code: 20,
    name: '查看和修改角色的权限列表'
  }
}
// 用户管理：
const UserCorrelation = {
  // UserCorrelation_Management: {
  //   code: 1,
  //   name: "用户相关操作"
  // },
  UserCorrelation_Management_Add_Or_Update: {
    code: 10,
    name: '创建管理员或修改账号'
  },
  UserCorrelation_Management_Update_Password: {
    code: 11,
    name: '给管理员修改密码'
  },
  UserCorrelation_Management_Forbid_Or_Delete: {
    code: 12,
    name: '禁用账号和删除账号'
  }
  // UserCorrelation_Management_Look_Detail: {
  //   code: 13,
  //   name: '查看管理员账号信息'
  // }
}
// 枚举管理：
const Enumeration = {
  // Enumeration_Management: {
  //   code: 0,
  //   name: "枚举和常量设置"
  // },
  Enumeration_Management_Add_One: {
    code: 26,
    name: '创建枚举或常量'
  },
  Enumeration_Management_Add_One_Item: {
    code: 27,
    name: '创建枚举选项'
  }
}
// 科目管理：
const Subject = {
  // Subject_Management: {
  //   code: 4,
  //   name: "科目管理"
  // },
  Subject_Management_Look_Subject: {
    code: 30,
    name: '查看科目'
  },
  Subject_Management_Add_Subject: {
    code: 31,
    name: '新增科目'
  },
  Subject_Management_Save_Subject_Unit: {
    code: 32,
    name: '保存科目单位（入库科目）'
  },
  Subject_Management_Look_Subject_Unit: {
    code: 33,
    name: '查看科目单位（入库科目）'
  }
}
// 食堂资金管理：
// 食堂资金管理学校端：
const CapitalSchool = {
  // CapitalSchool_Management: {
  //   code: 120,
  //   name: '食堂资金管理学校端
  // },
  CapitalSchool_Management_Inset_Shift_To_Record: {
    code: 121,
    name: '插入资金转入记录'
  },
  CapitalSchool_Management_Get_Base_Info_For_School: {
    code: 122,
    name: '获取学校账户基本信息（自动获取填充数据）'
  },
  CapitalSchool_Management_Shift_To_Record_Confirm_Or_Cancel: {
    code: 123,
    name: '资金转入记录确认或取消'
  },
  // CapitalSchool_Management_Look_Base_Info: {
  //   code: 131,
  //   name: '查看食堂资金总览'
  // },
  CapitalSchool_Management_Save_Base_Info: {
    code: 132,
    name: '保存食堂资金总览'
  },
  CapitalSchool_Management_Submit_Canteen_Apply: {
    code: 133,
    name: '提交资金申请'
  },
  CapitalSchool_Management_Update_Canteen_Apply: {
    code: 134,
    name: '修改资金申请内容'
  },
  CapitalSchool_Management_Cancel_Canteen_Apply: {
    code: 135,
    name: '取消资金申请'
  },
  CapitalSchool_Management_Look_Apply_History: {
    code: 136,
    name: '查询资金申请记录'
  },
  CapitalSchool_Management_Export_Apply_History: {
    code: 137,
    name: '导出资金申请记录'
  },
  CapitalSchool_Management_Query_For_Shift_To_Record: {
    code: 138,
    name: '查询资金转入记录'
  }
}
// 食堂资金管理中心学校端：
const CapitalVillagesAndTowns = {
  // CapitalVillagesAndTowns_Management: {
  //   code: 140,
  //   name: '食堂资金管理中心学校端
  // },
  CapitalVillagesAndTowns_Management_Audit_Canteen_Apply: {
    code: 141,
    name: '审批或驳回资金申请'
  },
  CapitalVillagesAndTowns_Management_Look_Canteen_Apply_History: {
    code: 142,
    name: '查询资金申请记录'
  },
  CapitalVillagesAndTowns_Management_Export_Canteen_Apply_History: {
    code: 143,
    name: '导出资金申请记录'
  }
}
// 食堂资金管理后勤端：
const CapitalCounty = {
  // CapitalCounty_Management: {
  //   code: 150,
  //   name: '食堂资金管理后勤端
  // },
  CapitalCounty_Management_Audit_Canteen_Apply: {
    code: 151,
    name: '审批或驳回资金申请'
  },
  CapitalCounty_Management_Look_Canteen_Apply_History: {
    code: 152,
    name: '查询资金申请记录'
  },
  CapitalCounty_Management_Export_Canteen_Apply_History: {
    code: 153,
    name: '导出资金申请记录'
  }
}
// 食堂资金管理城投端：
const CapitalCityInvestment = {
  // CapitalCityInvestment_Management: {
  //   code: 160,
  //   name: '食堂资金管理城投端
  // },
  CapitalCityInvestment_Management_Audit_Canteen_Apply: {
    code: 161,
    name: '审批或驳回资金申请'
  },
  CapitalCityInvestment_Management_Confirm_Transfer_Accounts: {
    code: 162,
    name: '确认转账'
  },
  CapitalCityInvestment_Management_Look_Canteen_Apply_History: {
    code: 163,
    name: '查询资金申请记录'
  },
  CapitalCityInvestment_Management_Export_Canteen_Apply_History: {
    code: 164,
    name: '导出资金申请记录'
  },
  // CapitalCityInvestment_Management_Download_Capital_Import_Template: {
  //   code: 165,
  //   name: '下载资金转入模版'
  // },
  // CapitalCityInvestment_Management_Import_Capital_Transfer_Accounts_History: {
  //   code: 166,
  //   name: '导入资金转入记录'
  // },
  CapitalCityInvestment_Management_Delete_Capital_Transfer_Accounts_History: {
    code: 167,
    name: '删除资金转入记录'
  },
  CapitalCityInvestment_Management_Look_Capital_Transfer_Accounts_History: {
    code: 168,
    name: '查看资金转入记录'
  },
  CapitalCityInvestment_Management_Audit_Capital_Shift_To_Record: {
    code: 169,
    name: '资金转入记录审批'
  }
}
// 食堂财务管理：
// 流水记录：
const IncomeAndExpenses = {
  // IncomeAndExpenses_Management: {
  //   code: 5,
  //   name: '流水记录'
  // },
  IncomeAndExpenses_Management_For_Add: {
    code: 50,
    name: '记流水账'
  },
  IncomeAndExpenses_Management_For_Update: {
    code: 51,
    name: '修改流水帐'
  },
  IncomeAndExpenses_Management_For_Delete: {
    code: 52,
    name: '删除流水帐'
  },
  IncomeAndExpenses_Management_For_Look: {
    code: 53,
    name: '查看流水帐'
  },
  IncomeAndExpenses_Management_Generate_Voucher: {
    code: 54,
    name: '生成上月凭证'
  },
  IncomeAndExpenses_Management_Generate_ReportForms_For_Remaining: {
    code: 55,
    name: '生成科目余额表'
  }
}
// 凭证：
const Voucher = {
  // Voucher_Management: {
  //   code: 180,
  //   name: '凭证'
  // },
  Voucher_Management_For_Search: {
    code: 181,
    name: '查询凭证'
  },
  Voucher_Management_For_Export_Out: {
    code: 182,
    name: '凭证导出'
  },
  Voucher_Management_Audit: {
    code: 183,
    name: '凭证审核'
  },
  Voucher_Management_For_Search_For_All: {
    code: 184,
    name: '凭证汇总查询'
  },
  Voucher_Management_For_Empty: {
    code: 185,
    name: '清空凭证'
  }
}
// 报表：
const ReportForms = {
  // ReportForms_Management: {
  //   code: 200,
  //   name: '报表'
  // },
  ReportForms_Management_Search_Balance: {
    code: 201,
    name: '查询科目余额表'
  },
  // ReportForms_Management_Export_Out_Balance: {
  //   code: 202,
  //   name: '导出科目余额表'
  // },
  ReportForms_Management_Search_Liabilities: {
    code: 203,
    name: '查询资产负债表'
  },
  ReportForms_Management_Search_Income_And_Expenses: {
    code: 205,
    name: '查询收支明细表'
  },
  ReportForms_Management_Search_Balance2: {
    code: 206,
    name: '清空科目余额表'
  }
}
// 库存管理：
const CanteenInventory = {
  // CanteenInventory_Management: {
  //   code: 8,
  //   name: '库存管理'
  // },
  CanteenInventory_Management_For_Save: {
    code: 80,
    name: '保存库存'
  },
  CanteenInventory_Management_For_Query: {
    code: 81,
    name: '查询库存'
  },
  CanteenInventory_Management_For_Delete: {
    code: 82,
    name: '删除库存'
  }
}
// 日常管理：
const CanteenDayToDay = {
  // CanteenDayToDay_Management: {
  //   code: 9,
  //   name: '日常管理'
  // },
  CanteenDayToDay_Management_AccompanyMeal_Look: {
    code: 100,
    name: '查看陪餐记录'
  },
  CanteenDayToDay_Management_AccompanyMeal_Save: {
    code: 101,
    name: '保存陪餐记录'
  },
  CanteenDayToDay_Management_AccompanyMeal_Delete: {
    code: 102,
    name: '删除陪餐记录'
  },
  CanteenDayToDay_Management_RetainSpecimen_Look: {
    code: 103,
    name: '查看留样记录'
  },
  CanteenDayToDay_Management_RetainSpecimen_Save: {
    code: 104,
    name: '保存留样记录'
  },
  CanteenDayToDay_Management_RetainSpecimen_Delete: {
    code: 105,
    name: '删除留样记录'
  },
  CanteenDayToDay_Management_Disinfect_Look: {
    code: 106,
    name: '查看消杀记录'
  },
  CanteenDayToDay_Management_Disinfect_Save: {
    code: 107,
    name: '保存消杀记录'
  },
  CanteenDayToDay_Management_Disinfect_Delete: {
    code: 108,
    name: '删除消杀记录'
  },
  CanteenDayToDay_Management_Train_Look: {
    code: 109,
    name: '查看培训记录'
  },
  CanteenDayToDay_Management_Train_Save: {
    code: 110,
    name: '保存培训记录'
  },
  CanteenDayToDay_Management_Train_Delete: {
    code: 111,
    name: '删除培训记录'
  }
}
// 系统设置：
const SystemSetting = {
  // SystemSetting_Management: {
  //   code: 7,
  //   name: '食堂基本信息'
  // },
  SystemSetting_Management_Look_Base_Info: {
    code: 70,
    name: '查看基本信息'
  },
  SystemSetting_Management_Save_Base_Info: {
    code: 71,
    name: '保存基本信息'
  },
  SystemSetting_Management_Look_Base_Balance: {
    code: 72,
    name: '查询科目初期余额'
  },
  SystemSetting_Management_Save_Base_Balance: {
    code: 73,
    name: '插入科目初期余额'
  }
}
// 人员管理：
const Personnel = {
  // Personnel_Management: {
  //   code: 250,
  //   name: '人员管理'
  // },
  Personnel_Management_Query: {
    code: 251,
    name: '查询食堂人员'
  },
  Personnel_Management_Add: {
    code: 252,
    name: '添加食堂人员'
  },
  Personnel_Management_Update: {
    code: 253,
    name: '修改食堂人员'
  },
  Personnel_Management_Delete: {
    code: 254,
    name: '删除食堂人员'
  }
}
// 预警配置：
const WarningConfig = {
  // WarningConfig_Management: {
  //   code: 271,
  //   name: '后台配置'
  // },
  WarningConfig_Management_Add_Food_Price: {
    code: 300,
    name: '新增食材单价区间'
  },
  WarningConfig_Management_Update_Food_Price: {
    code: 301,
    name: '修改食材单价区间'
  },
  WarningConfig_Management_Query_Food_Price: {
    code: 302,
    name: '查询食材单价区间'
  },
  WarningConfig_Management_Add_Time_Config: {
    code: 303,
    name: '新增预警时间配置'
  },
  WarningConfig_Management_Query_Time_Config: {
    code: 304,
    name: '预警时间配置查询'
  },
  WarningConfig_Management_Able_Time_Config: {
    code: 305,
    name: '激活或者停用预警时间配置'
  },
  WarningConfig_Management_Delete_Time_Config: {
    code: 306,
    name: '删除预警时间配置'
  },
  WarningConfig_Management_Query_Time_Config_Plus: {
    code: 307,
    name: '预警时间配置查询plus'
  }
}
// 预警查询：
const WarningQuery = {
  // WarningQuery_Management: {
  //   code: 272,
  //   name: '预警'
  // },
  WarningQuery_Management_Handler: {
    code: 400,
    name: '预警处理'
  },
  WarningQuery_Management_Query: {
    code: 401,
    name: '预警查询'
  },
  WarningQuery_Management_Query_For_Have_Handler: {
    code: 402,
    name: '已处理预警查询'
  }
}

// 学校信息维护：
// TODO:
const SchoolInfoMaintain = {
  SchoolInfoMaintain_Management: {
    code: 308,
    name: '学校信息维护'
  }
}

export default {
  Announcement,
  Organization,
  RoleAuthority,
  UserCorrelation,
  Enumeration,
  Subject,
  CapitalSchool,
  CapitalVillagesAndTowns,
  CapitalCounty,
  CapitalCityInvestment,
  IncomeAndExpenses,
  Voucher,
  ReportForms,
  CanteenInventory,
  CanteenDayToDay,
  SystemSetting,
  Personnel,
  WarningConfig,
  WarningQuery,
  SchoolInfoMaintain
}
